const SENSITIVE_ERROR_TEXT = [
  /connection\s*string/i,
  /data source=/i,
  /initial catalog=/i,
  /trustservercertificate/i,
  /password=/i,
  /pwd=/i,
  /user id=/i,
  /api[_\s-]?key/i,
  /parameter ['"]/i,
  /value cannot be null/i,
  /system\.\w+/i,
  /sql(exception|client)/i,
  /entity framework/i,
  /\.cs:line/i,
  /stack trace/i,
  /inner exception/i,
  /sendgrid/i,
  /\/home\/runner/i,
  /bearer [a-z0-9._-]{12,}/i,
  /-----begin/i,
];

export const isSensitiveErrorText = (message: string): boolean =>
  SENSITIVE_ERROR_TEXT.some((pattern) => pattern.test(message));

export const toPublicErrorMessage = (
  message: string | null | undefined,
  status: number | null | undefined,
  fallback: string,
  production = process.env.NODE_ENV === 'production',
): string => {
  const text = typeof message === 'string' ? message.trim() : '';
  if (!production) {
    return text || fallback;
  }

  if ((status ?? 0) >= 500 || (text.length > 0 && isSensitiveErrorText(text))) {
    return fallback;
  }

  return text || fallback;
};
